// extracted by mini-css-extract-plugin
export default {"areadatosusuario":"Contratante_areadatosusuario__ojb8+","areamensaje":"Contratante_areamensaje__1KK4k","noMuestra":"Contratante_noMuestra__nFwim"};